import React from "react";

import "./pieceFilterKeywordList.css";

interface PieceFilterKeywordListProps {
    keywords: string[];
    active: string[];
    onUpdate: (v: string[]) => void;
    maxElements?: number;
}

export default function PieceFilterKeywordList(props: PieceFilterKeywordListProps) {
    return <div className="piece-filter-keyword-list">
        {props.keywords.map((e, i) => {
            if(props.maxElements && props.maxElements <= i) return;
            return <div onClick={() => {
                if(props.active.includes(e)) {
                    props.onUpdate(props.active.filter(y => y !== e));
                }else {
                    props.onUpdate([...props.active, e]);
                }
            }} className={"round-button keyword" + (props.active.includes(e) ? " active" : "")}><h5>{e}</h5></div>
        })}
    </div>
}